import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#cursos", label: "Cursos" },
  { href: "#mentores", label: "Membresías" },
  { href: "#testimonios", label: "Extras" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${
        scrolled
          ? "backdrop-blur-xl bg-[#030303]/85 border-b border-[#B49A6C]/10"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="navbar-logo"
          className="font-display text-base tracking-[0.22em] text-[#E8E5DC]"
        >
          SUBCONSCIOUS<span className="text-[#B49A6C] mx-1">·</span>LAB
        </a>

        <ul className="hidden lg:flex items-center gap-12">
          {links.map((l) => (
            <li key={l.href}>
              <a
                data-testid={`nav-link-${l.href.replace("#", "")}`}
                href={l.href}
                className="hover-line text-[10px] uppercase tracking-[0.3em] text-[#807C70] hover:text-[#E8E5DC] transition-colors"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="#contacto"
          data-testid="navbar-cta"
          className="hidden lg:inline-flex items-center gap-3 text-[10px] uppercase tracking-[0.3em] text-[#E8E5DC] border border-[#B49A6C]/40 px-6 py-3 hover:border-[#B49A6C] hover:text-[#B49A6C] transition-colors duration-500"
        >
          Inscribirse
        </a>

        <button
          data-testid="navbar-menu-toggle"
          aria-label="Menu"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-[#E8E5DC]"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="navbar-mobile-menu"
          className="lg:hidden border-t border-[#B49A6C]/10 bg-[#030303]/95 backdrop-blur-xl"
        >
          <ul className="px-6 py-8 flex flex-col gap-6">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="text-xs uppercase tracking-[0.3em] text-[#807C70]"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#contacto"
                onClick={() => setOpen(false)}
                className="inline-block text-[10px] uppercase tracking-[0.3em] text-[#E8E5DC] border border-[#B49A6C]/40 px-6 py-3"
              >
                Inscribirse
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
